import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";

export default function PersonalIcon(props) {
  const width = props.width || 30;
  const height = props.height || 30;

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 9C11 6.75228 12.7523 5 15 5C17.2477 5 19 6.75228 19 9V12.0703C17.8233 11.3896 16.4571 11 15 11C13.5429 11 12.1767 11.3896 11 12.0703V9ZM9 13.7084V9C9 5.64772 11.6477 3 15 3C18.3523 3 21 5.64772 21 9V13.7084C22.2447 15.1186 23 16.9711 23 19C23 23.4183 19.4183 27 15 27C10.5817 27 7 23.4183 7 19C7 16.9711 7.75527 15.1186 9 13.7084ZM9 19C9 15.6863 11.6863 13 15 13C18.3137 13 21 15.6863 21 19C21 22.3137 18.3137 25 15 25C11.6863 25 9 22.3137 9 19ZM15 17C14.4477 17 14 17.4477 14 18C14 18.5523 14.4477 19 15 19C15.5523 19 16 18.5523 16 18C16 17.4477 15.5523 17 15 17ZM16 20.8293C17.1652 20.4175 18 19.3062 18 18C18 16.3431 16.6569 15 15 15C13.3431 15 12 16.3431 12 18C12 19.3062 12.8348 20.4175 14 20.8293V22C14 22.5523 14.4477 23 15 23C15.5523 23 16 22.5523 16 22V20.8293Z"
          fill="url(#paint0_linear_personal)"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_personal"
            x1="7"
            y1="8.20482"
            x2="20.958"
            y2="27.2185"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
